import React from 'react';

const DeliveriesTab = ({ deliveries, onAddDelivery, onRemoveDelivery, onEditDelivery }) => (
  <div style={{ background: 'white', borderRadius: '12px', padding: '25px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '15px', borderBottom: '2px solid #f3f4f6' }}>
      <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#1f2937', margin: 0 }}>Today's Deliveries</h3>
      <button onClick={onAddDelivery} style={{ padding: '10px 20px', background: '#667eea', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 500 }}>+ Add Delivery</button>
    </div>
    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
      {deliveries.map(d => (
        <li key={d.id} style={{ padding: '15px', border: '1px solid #e5e7eb', borderRadius: '8px', marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h4 style={{ fontSize: '16px', color: '#1f2937', margin: 0 }}>{d.name}</h4>
            <p style={{ fontSize: '13px', color: '#6b7280', margin: '5px 0' }}>📍 {d.location}</p>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: 0 }}>⚖️ Weight: {d.weight}kg | ⏰ Time: {d.timeWindow.start}:00 - {d.timeWindow.end}:00</p>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: 0 }}>🌐 Lat: {d.coords[1]}, Long: {d.coords[0]}</p>
          </div>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <span style={{
              padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: 500,
              background: d.priority === 'high' ? '#fee2e2' : d.priority === 'medium' ? '#fef3c7' : '#dbeafe',
              color: d.priority === 'high' ? '#991b1b' : d.priority === 'medium' ? '#92400e' : '#1e40af'
            }}>
              {d.priority.charAt(0).toUpperCase() + d.priority.slice(1)}
            </span>
            <button onClick={() => onEditDelivery(d)} style={{ minWidth: '90px', padding: '8px 12px', background: '#fbbf24', color: 'black', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', transition: 'all 0.2s ease-in-out' }}
              onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}>
              ✏️ Edit
            </button>
            <button onClick={() => onRemoveDelivery(d.id)} style={{ minWidth: '90px', padding: '8px 12px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', transition: 'all 0.2s ease-in-out' }}
              onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}>
              🗑️ Delete
            </button>
          </div>
        </li>
      ))}
    </ul>
  </div>
);

export default DeliveriesTab;
